export const requiredFieldsCustom = ['phone', 'name', 'file'];